module.exports = __webpack_public_path__ + "media/footer/fastweb-logo-a-monster-company-429425e0.svg";